import { render } from "./AboutAlltv.vue?vue&type=template&id=48ca67c1&scoped=true"
import script from "./AboutAlltv.vue?vue&type=script&lang=js"
export * from "./AboutAlltv.vue?vue&type=script&lang=js"

import "./AboutAlltv.vue?vue&type=style&index=0&id=48ca67c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ca67c1"]])

export default __exports__